import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=a90ef0ce&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=a90ef0ce&prod&lang=css&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=a90ef0ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90ef0ce",
  null
  
)

export default component.exports